<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            @searchResource="searchResource" 
            @create="dialog = true"
          />
        </v-col>
        <v-col cols="12" CustomPageActions v-if="user.hq">
          <v-card class="px-3" :loading="loading">
            <v-row class="pa-0">
              <v-col cols="6">
                <v-btn block text color="success" :loading="loading" @click="syncEmailServer()"
                  :class="`${arabic?'arFont':'enFont'}`"
                >
                  <v-icon left>sync</v-icon>
                  SYNC USERS TO E-MAIL SERVER
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" Headers>
          <v-card class="px-3" :loading="loading">
            <v-card-text class="py-2">
              <v-row class="pa-0">
                <v-col cols="3" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  {{i18n.name}}
                </v-col>
                <v-col cols="3" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  {{i18n.userEmail}}
                </v-col>
                <v-col cols="2" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  {{i18n.access}}
                </v-col>
                <v-col cols="3" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  {{i18n.userRole}}
                </v-col>
                <v-col cols="1" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.status}}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-expansion-panels focusable>
                <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
                  <v-expansion-panel-header>
                    <v-row class="pa-0 align-center">
                      <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 font-weight-bold`">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">{{r.name}}</span>
                          </template>
                          <div class="text-center">
                            <div><img :src="r.image"></div>
                            <div :class="`${arabic?'arFont':'enFont'}`">{{r.name}}</div>
                            <div :class="`${arabic?'arFont':'enFont'}`">{{r.email}}</div>
                            <div :class="`${arabic?'arFont':'enFont'}`">{{r.provider}}</div>
                            <div :class="`${arabic?'arFont':'enFont'}`">{{r.role}}</div>
                            <div :class="`${arabic?'arFont':'enFont'}`">{{r.countries}}</div>
                            <div :class="`${arabic?'arFont':'enFont'}`">{{r.departments}}</div>
                          </div>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1`">
                        <div style="font-size:11px;">{{r.email}}</div>
                      </v-col>
                      <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-left`">
                        <v-switch @change="updateResource(r)" 
                          hide-details 
                          :class="`${arabic?'arFont':'enFont'}`" 
                          :name="i18n.access"
                          :label="i18n.access" v-model="r.access"></v-switch>
                      </v-col>
                      <v-col cols="11" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-left`">
                        <v-select
                          :items="roles"
                          v-model="r.role"
                          :label="i18n.userRole"
                          :name="i18n.userRole"
                          outlined
                          :disabled="!user.hq"
                          :readonly="!user.hq"
                          hide-details
                          dense
                          @change="updateResource(r)"
                          item-value="slug"
                          :class="`${arabic?'arFont':'enFont'}`"

                        >
                          <template v-slot:selection="{ attr, on, item, selected }">
                            <span
                              v-bind="attr"
                              :input-value="selected"
                              v-on="on"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              {{i18n[item.slug]}}
                            </span>
                          </template>
                          <template v-slot:item="{ item }">
                            <span
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              {{i18n[item.slug]}}
                            </span>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="1" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 py-1 adminSwitch text-center`">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <v-avatar
                                size="10"
                                :color="r.online?'success':'error'"
                              >
                              </v-avatar>
                            </span>
                          </template>
                          <div :class="`${arabic?'arFont':'enFont'}`">{{getFormat(r.updated_at)}}</div>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-divider class="pb-3"></v-divider>
                    <v-row class="pa-0 align-center">
                      <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-left`">
                        <v-autocomplete
                          :items="countries"
                          v-model="r.countries"
                          :label="i18n.userCountries"
                          outlined
                          autocomplete="disabled"
                          hide-details
                          dense
                          :disabled="!user.hq"
                          chips
                          multiple
                          item-value="id"
                          :class="`${arabic?'arFont':'enFont'}`"

                        >
                          <template v-slot:selection="{ attr, on, item, selected }">
                            <span
                              v-bind="attr"
                              :input-value="selected"
                              v-on="on"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                            </span>
                          </template>
                          <template v-slot:item="{ item }">
                            <span
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              {{i18n[item.slug]}}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-left`">
                        <v-autocomplete
                          :items="programs"
                          v-model="r.programs"
                          :label="i18n.userPrograms"
                          outlined
                          hide-details
                          dense
                          autocomplete="disabled"
                          chips
                          multiple
                          item-value="id"
                          :class="`${arabic?'arFont':'enFont'}`"

                        >
                          <template v-slot:selection="{ attr, on, item, selected }">
                            <span
                              v-bind="attr"
                              :input-value="selected"
                              v-on="on"
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              <v-chip x-small>{{i18n[item.slug]}}</v-chip>
                            </span>
                          </template>
                          <template v-slot:item="{ item }">
                            <span
                              :class="`${arabic?'arFont':'enFont'}`"
                            >
                              {{i18n[item.slug]}}
                            </span>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-left`">
                        <v-switch 
                          @change="updateResource(r)" 
                          hide-details 
                          :disabled="!user.hq"
                          :readonly="!user.hq"
                          :class="`${arabic?'arFont':'enFont'}`" 
                          :name="i18n.hq"
                          :label="i18n.hq" v-model="r.hq">
                        </v-switch>
                      </v-col>
                      <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-left`">
                        <v-switch 
                          @change="updateResource(r)" 
                          hide-details 
                          :disabled="!user.hq"
                          :readonly="!user.hq"
                          :class="`${arabic?'arFont':'enFont'}`" 
                          :name="i18n.branchManager"
                          :label="i18n.branchManager" v-model="r.manager">
                        </v-switch>
                      </v-col>
                      <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-left`">
                        <v-switch 
                          @change="updateResource(r)" 
                          hide-details 
                          :disabled="!user.hq"
                          :readonly="!user.hq"
                          :class="`${arabic?'arFont':'enFont'}`" 
                          :name="i18n.programManager"
                          :label="i18n.programManager" v-model="r.program_manager">
                        </v-switch>
                      </v-col>
                      <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-left`">
                        <v-switch 
                          @change="updateResource(r)" 
                          hide-details 
                          :class="`${arabic?'arFont':'enFont'}`" 
                          :name="i18n.assign"
                          :label="i18n.assign" v-model="r.assign">
                        </v-switch>
                      </v-col>
                      <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-left`">
                        <v-text-field
                          :label="i18n.assignRatio"
                          hide-details 
                          @change="updateResource(r)" 
                          outlined
                          autocomplete="disabled"
                          dense
                          :disabled="!r.assign"
                          @keypress="isNumber($event)"
                          :class="`${arabic?'arFont':'enFont'}`"
                          v-model="r.assign_ratio"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-1 adminSwitch text-left`">
                        <v-btn color="success" block text @click="updateResource(r)">
                          <v-icon left>save</v-icon>
                          <span>{{i18n.save}}</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: { Search, Paging },
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
      },
      resourceKeys:[
        {name: 'name', label:'name', type:'text', required:true },
        {name: 'email', label:'email', type:'text', required:true },
        {name: 'role', label:'userRole', type:'select', items:'roles', required:true },
        {name: 'access', label:'access', type:'switch', required:true },
      ],
      resourceSettings:{
        resourceName:null,
        search:true,
        create:false,
        pagination:true,
      },
      newResource:{},
      programs:[],
      countries:[],
      roles:[],
    }
  },
  
  methods: {
    async syncEmailServer(){
      this.loading = true
      let b = await axios.get('https://aramccoapp.com/back/public/api/v1/syncUsers').then(x=>x.data)
      console.log(b)
      this.loading = false
    },
    async loadSettingsItems(){
      return new Promise(async (res, rej)=>{
        let ks = ['countries', 'programs', 'roles'];
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = await this.$store.dispatch('getResource', {resource:`/${f}`})
            if(!t.error)
            t.forEach(x=> this.$store.state.i18n.en[x.slug] = x.en)
            t.forEach(x=> this.$store.state.i18n.ar[x.slug] = x.ar)
            t.forEach(x=> this.$store.state.i18n.fr[x.slug] = x.fr)
            this[f].push(...t)
          }
          res(true)
        })()
      })
    },
    validate(newResource) {
      return true
    },
    getItems(items) {
      return this[items]
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        }
        this.loading = false
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}`})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        this.loading = false
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(r.countries && r.countries.length) {
          r.countries = r.countries.map(x=>{
            if(x.id) {
              return x.id
            } else {
              return x
            }
          })
        }
        if(r.programs && r.programs.length) {
          r.programs = r.programs.map(x=>{
            if(x.id) {
              return x.id
            } else {
              return x
            }
          })
        }
        console.log(r)
        await this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        this.loadResource()
        this.loading = false
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:this.$route.path + `/${r.id}`})
        this.loadResource()
        this.loading = false
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('postResource', {resource:this.$route.path + `/${r.id}`, value:r})
        this.loadResource()
        this.loading = false
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    }
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.loadSettingsItems()
    this.setResourceName()
    await this.loadResource()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>